import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { takeUntil } from 'rxjs';
import { GptModelList, OpenAIModel } from '@models/open-ai-gpt.model';
import { BaseComponent } from 'src/app/components/base.component';
import { ThirdPartyManager } from '@managers/third-party.manager';

@Component({
    selector: 'lex-manage-open-ai-account-setting-dialog',
    templateUrl: './manage-open-ai-account-setting-dialog.component.html',
    styleUrls: ['./manage-open-ai-account-setting-dialog.component.scss'],
    standalone: false
})

export class ManageOpenAIAccountSettingDialogComponent extends BaseComponent {
  public models = GptModelList;
  public openAiSettingForm: FormGroup;
  public isLinked: boolean = false;
  private currentKey: string = '';
  private currentAccountId: string = '';

  constructor(
    private formBuilder: FormBuilder,
    private thirdPartyManager: ThirdPartyManager,
    private dialogRef: MatDialogRef<ManageOpenAIAccountSettingDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private accountId: string
  ) {
    super();
    this.currentAccountId = accountId;
    this.openAiSettingForm = this.formBuilder.group({
      apiKey: ['', Validators.required],
      apiModel: [OpenAIModel.GPT4Omni, Validators.required]
    });
    this.thirdPartyManager.getOpenAiIntegrationByAccountId(this.currentAccountId)
      .pipe(takeUntil(this.destroy$))
      .subscribe((settings) => {
        if (settings.apiKey) {
          this.openAiSettingForm.get('apiKey')?.setValue(settings.apiKey);
          this.currentKey = settings.apiKey;
          this.isLinked = true;
        }
        if (settings.model) {
          this.openAiSettingForm.get('apiModel')?.setValue(settings.model);
        }
      });
  }

  public link(): void {
    if (this.openAiSettingForm.invalid) {
      return;
    }
    this.thirdPartyManager.linkOpenAiIntegrationByAccountId(this.currentAccountId, {
      apiKey: this.openAiSettingForm.get('apiKey')?.value,
      model: this.openAiSettingForm.get('apiModel')?.value
    }).subscribe(() => this.dialogRef.close(true));
  }

  public submit(): void {
    if (this.openAiSettingForm.invalid) {
      return;
    }
    const apiKey = this.openAiSettingForm.dirty && this.openAiSettingForm.get('apiKey')?.value !== this.currentKey
      ? this.openAiSettingForm.get('apiKey')?.value
      : '';
    this.thirdPartyManager.updateOpenAiIntegrationByAccountId(this.currentAccountId, {
      apiKey: apiKey,
      model: this.openAiSettingForm.get('apiModel')?.value
    }).subscribe(() => this.dialogRef.close(true));
  }

  public unlink(): void {
    this.thirdPartyManager.unlinkOpenAiIntegrationByAccountId(this.currentAccountId)
      .subscribe(() => this.dialogRef.close(true));
  }
}